module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-cjdr.2140d415.jpg";